import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 transition-colors duration-200",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 transition-colors duration-200",
        outline:
          "border-2 border-primary text-primary bg-background hover:bg-primary/5 transition-colors duration-200",
        secondary:
          "bg-background border-2 border-primary text-primary hover:bg-primary/5 transition-colors duration-200",
        ghost: "hover:bg-muted hover:text-foreground transition-colors duration-200",
        link: "text-primary underline-offset-4 hover:underline transition-colors duration-200",
        gold:
          "bg-accent text-accent-foreground shadow-sm hover:bg-accent/90 shadow-accent-glow transition-all duration-200",
        "outline-gold":
          "border-2 border-accent text-accent bg-transparent hover:bg-accent/10 transition-colors duration-200",
        "hero-primary":
          "bg-primary-foreground text-primary font-semibold hover:bg-primary-foreground/90 transition-colors duration-200",
        "hero-outline":
          "border-2 border-primary text-primary bg-background hover:bg-primary/5 transition-colors duration-200",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-lg px-10 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
